import $ from 'jQuery';


let form;
let contact;
let message;
let button;
const recipient = 'mpo@iretdev.be';
const project = 'Rive Gauche';
const projectSlug = 'iret';
const source = 'website';
const apiUrl = 'http://piaf-messages.herokuapp.com/api/v1/messages';


function init() {

  form = $('.js-form-submit');
  contact = $('.Contact');
  message = $('.Contact__messageSent');
  button = contact.find('.Contact__button');

  if (form[0]) {
    _attachEvents();
  }
}


function _attachEvents() {
  form.on('submit', _handleSubmitForm);
}


function _handleSubmitForm() {
  const name = form[0]['name'].value;
  const email = form[0]['email'].value;
  const phoneNumber = form[0]['phoneNumber'].value;
  const _message = form[0]['message'].value;

  const message = `
    Nom - ${name} |
    Email -  ${email} |
    Téléphone - ${phoneNumber} |
    Message - ${_message}
  `;

  const data = {
    message: {
      recipient: recipient,
      project: project,
      project_slug: projectSlug,
      source: source,
      phone: phoneNumber,
      content: message,
      name: name,
      sender: email,
    },
  };

  $.ajax({
    url: apiUrl,
    data: data,
    type: 'POST',
    crossDomain: true,
    crossOrigin: true,
    dataType: 'json',
  }).done(_requestSuccess);
}


function _requestSuccess() {
  $(form[0]['name']).val('');
  $(form[0]['email']).val('');
  $(form[0]['phoneNumber']).val('');
  $(form[0]['message']).val('');
  message.show();
  button.css({ opacity: 0, pointerEvents: 'none' });
}


export default {
  init,
};


// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js